import { DEFAULT_PAGINATOR } from "../constants/api";
import ReviewPlanItemService from "../services/review-plan-item-service";

const RESET_ALL = "reviewPlanItem/RESET_ALL";
const GET_ALL = "reviewPlanItem/GET_ALL";
const RESET_DROPDOWN = "reviewPlanItem/RESET_DROPDOWN";
const GET_ALL_DROPDOWN = "reviewPlanItem/GET_ALL_DROPDOWN";
const GET_BY_ID = "reviewPlanItem/GET_BY_ID";
const UPDATE = "reviewPlanItem/UPDATE";
const DELETE = "reviewPlanItem/DELETE";

const initalState = {
  list: {
    data: [],
    paginator: DEFAULT_PAGINATOR,
  },
  detail: null,
  dropdown: {
    data: [],
    paginator: DEFAULT_PAGINATOR,
  }
};

const reviewPlanItem = (state = { ...initalState }, { type, payload }) => {
  let findIdx = -1
  switch (type) {
    case RESET_ALL:
      return initalState
    case GET_ALL:
      return {
        ...state,
        list: {
          data: payload.data,
          paginator: payload.paginator
        },
      };
    case GET_ALL_DROPDOWN:
      return {
        ...state,
        dropdown: {
          data: [...state.dropdown.data, ...payload.data],
          paginator: payload.paginator
        },
      };
    case GET_BY_ID:
      return {
        ...state,
        detail: payload.data
      };
    case RESET_DROPDOWN:
      return {
        ...state,
        dropdown: {
          data: [],
          paginator: DEFAULT_PAGINATOR
        }
      };
    case UPDATE:
      if (state.detail && state.detail.id === payload.data.id) {
        state.detail = {
          ...state.detail,
          ...payload.data,
        }
      }
      findIdx = state.list.data.findIndex(d => d.id === payload.data.id)
      if (findIdx > -1) {
        state.list.data[findIdx] = {
          ...state.list.data[findIdx],
          ...payload.data
        }
      }
      findIdx = state.dropdown.data.findIndex(d => d.id === payload.data.id)
      if (findIdx > -1) {
        state.dropdown.data[findIdx] = {
          ...state.dropdown.data[findIdx],
          ...payload.data
        }
      }
      return {
        ...state,
      };
    case DELETE:
      if (state.detail && state.detail.id === payload.data.id) {
        state.detail = null
      }
      findIdx = state.list.data.findIndex(d => d.id === payload.data.id)
      if (findIdx > -1) {
        state.list.data.splice(findIdx, 1)
        state.list.paginator = {
          ...state.list.paginator,
          totalItems: state.list.paginator.totalItems - 1,
          itemTo: state.list.paginator.itemTo - 1,
        }
      }
      findIdx = state.dropdown.data.findIndex(d => d.id === payload.data.id)
      if (findIdx > -1) {
        state.dropdown.data.splice(findIdx, 1)
        state.dropdown.paginator = {
          ...state.dropdown.paginator,
          totalItems: state.dropdown.paginator.totalItems - 1,
          itemTo: state.dropdown.paginator.itemTo - 1,
        }
      }
      return {
        ...state,
      };
    default:
      return state;
  }
};
export default reviewPlanItem;

export const getAll = (reviewPlanId, params, isDropdown = false) => async (dispatch) => {
  const resp = await ReviewPlanItemService.getAll(reviewPlanId, params);
  if (resp.status && resp.status === 200) {
    if (isDropdown) {
      dispatch({ type: GET_ALL_DROPDOWN, payload: resp.data });
    } else {
      dispatch({ type: GET_ALL, payload: resp.data });
    }
  }
  return resp
};

export const getByIdDropdown = async (reviewPlanId, id) => {
  const resp = await ReviewPlanItemService.getById(reviewPlanId, id);
  if (resp.status && resp.status === 200) {
    return resp.data.data
  }
  return null
};

export const getById = (reviewPlanId, id) => async (dispatch) => {
  const resp = await ReviewPlanItemService.getById(reviewPlanId, id);
  if (resp.status && resp.status === 200) {
    dispatch({ type: GET_BY_ID, payload: resp.data });
  }
  return resp
};

export const resetAll = () => async (dispatch) => {
  dispatch({ type: RESET_ALL });
};

export const resetDropdown = () => async (dispatch) => {
  dispatch({ type: RESET_DROPDOWN });
};

export const updateById = (reviewPlanId, id, params) => async (dispatch) => {
  const resp = await ReviewPlanItemService.updateById(reviewPlanId, id, params);
  if (resp.status && resp.status === 200) {
    dispatch({ type: UPDATE, payload: resp.data });
  }
  return resp
};

export const create = (reviewPlanId, params) => {
  return ReviewPlanItemService.create(reviewPlanId, params);
};

export const deleteById = (reviewPlanId, id) => async (dispatch) => {
  const resp = await ReviewPlanItemService.deleteById(reviewPlanId, id);
  if (resp.status && resp.status === 200) {
    dispatch({ type: DELETE, payload: resp.data });
  }
  return resp
};
